import {
  ChildTicketInput,
  CreateChildTicketInput,
  CreateTicketInput,
} from "shared";
import { axiosClient } from "utilz";

import { combineDateAndTimeV2, getMspId } from "utilz/helpers";

export const convertToChildTicket = async ({
  parentTcketId,
  childTickets,
}: ChildTicketInput) => {
  try {
    const url = `/v2/servicedesk/convert/childticket/${parentTcketId}`;

    const response = await axiosClient.patch(`${url}`, { childTickets });
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const createChildTicket = async ({
  ticketId,
  isBillable,
  checklist,
  board,
  priority,
  status,
  summary,
  description,
  resources,
  urgency,
  workType,
  ticketType,
  ticketSubtype,
  source,
  impact,
  sla,
  customer,
  site,
  ticket_site_id,
  user,
  schedule,
  location,
  generalVariable,
  ticketVariable,
  budgetedHours,
  attachments,
  estimatedEndTime,
  tags,
  ccMembers,
}: CreateChildTicketInput) => {
  const data = {
    ticket_summary: summary,
    ticket_description: description,
    board_id: board,
    priority: priority,
    is_billable: isBillable,
    ...(urgency && { urgency: urgency }),
    ...(workType && { work_type_id: workType }),
    ticket_type_id: ticketType,
    ticket_status: status,
    ticket_subtype_id: ticketSubtype,
    source_id: source,
    impact: impact,
    location_id: location,
    ticket_site_id: site,
    customer_id: customer,
    customer_user_id: user,
    budgeted_hours: budgetedHours,
    sla_id: sla,
    ...(generalVariable &&
      generalVariable.length > 0 && {
        general_variable_attributes: generalVariable,
      }),
    ...(ticketVariable &&
      ticketVariable.length > 0 && {
        ticket_variable_attributes: ticketVariable,
      }),
    checklists: checklist,
    attachments: attachments,
    estimated_end_date: estimatedEndTime,
    ...(tags && tags.length > 0 && { tags }),
    ...(ccMembers && ccMembers.length > 0 && { cc_members: ccMembers }),
    ...(resources &&
      resources?.length > 0 && {
        schedulings: {
          ...(resources &&
            resources?.length > 0 && {
              resource_id: resources?.map((res) => {
                return res.mapping_id;
              }),
            }),
          schedule_times:
            schedule?.map((sec) => {
              if (
                sec.startDate &&
                sec.startTime &&
                sec.endDate &&
                sec.endTime
              ) {
                return {
                  start_time: combineDateAndTimeV2({
                    date: sec.startDate,
                    time: sec.startTime,
                  }),
                  end_time: combineDateAndTimeV2({
                    date: sec.endDate,
                    time: sec.endTime,
                  }),
                };
              }
            }) || [],
        },
      }),
  };
  try {
    const response = await axiosClient.post(
      `/v2/servicedesk/childticket/${ticketId}`,
      data,
    );
    const resData = response.data;
    console.log(resData);
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const unlinkChildTicket = async (childTicketId: string) => {
  try {
    const url = `servicedesk/remove/childticket/${childTicketId}`;

    const response = await axiosClient.patch(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
